<template>
  <div v-if="showUnavailableHeader">
    <!-- Vue Lottie Player with a fallback image -->
    <div
      v-if="backgroundLottieUrl?.length > 0 && !animationFailed"
      class="store-unavailable-bg-lottie"
    >
      <VueLottiePlayer
        name="confettiAnim"
        loop
        :path="backgroundLottieUrl"
        width="100%"
        height="100%"
        background="transparent"
        @animControl="onLottieAnimControl"
        @error="onAnimationError"
      />
    </div>

    <!-- Fallback Image -->
    <img
      v-else
      class="store-unavailable-bg-img"
      :style="{
        backgroundImage: `url(${backgroundImage})`,
      }"
    />

    <div class="store-unavailable-container">
      <div class="fs-16 fw-700 color-text">{{ titleText }}</div>
      <div class="fs-14 fw-400 color-slaty">{{ subText }}</div>
      <button
        class="fs-14 bold btn w100 primary mt4"
        @click="buttonCTAClickHandler()"
        v-if="showButton"
        v-ripple
      >
        {{ buttonCTA }}
      </button>
      <div
        v-if="isNearByTakeAwayOrDineinAvailable && isNearByStorePickupEnabled"
        class="store-unavailable-takeaway-container"
      >
        <div class="inline-flex align-items-center gap16">
          <img
            class="nearby-store-divider-image"
            :src="nearbyStoreDividerLeftImage"
          />
          <span>{{ nearbyStoreDividerLabel }}</span>
          <img
            class="nearby-store-divider-image"
            :src="nearbyStoreDividerRightImage"
          />
        </div>
        <div class="fs-16 fw-700">
          {{ nearestStoreSectionTitle }}
        </div>
        <div class="border br12 pd12 width100">
          <address-card
            v-if="nearestTakeawayStore?.store"
            :data-item="nearestTakeawayStore?.store"
            :data-title="nearestTakeawayStore?.store.name"
            :data-address="nearestTakeawayStore?.store.address"
            :data-distance="
              nearestTakeawayStore?.store?.stations[0]?.driveDistanceInKm
            "
            :data-time="
              nearestTakeawayStore?.store?.stations[0]?.driveTimeInSec
            "
            :data-is-store-open="nearestTakeawayStore?.store.pickUpEnable"
            :data-home-card="true"
            :addressCardClass="addressCardClass"
            :data-on-card-click="() => {}"
          />
          <div class="inline-flex gap12 mt16 width100">
            <button
              v-if="isNearByTakeAwayAvaialable"
              class="fs-14 btn primary"
              @click="handleProceedTakeaway"
              v-ripple
            >
              Proceed with <span class="bold">Takeaway</span>
            </button>
            <button
              v-if="isNearByDineInAvaialable"
              class="fs-14 btn primary"
              @click="handleProceedDinein"
              v-ripple
            >
              Proceed with <span class="bold">Dine-In</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineAsyncComponent } from "vue";
import { StoreUnavailabilityKeys } from "../helpers/addressConstants";
import { OrderTypesCode } from "../helpers/orderTypesConstants";
import AddressCard from "./AddressCard.vue";
import LocalStorageFunc from "../helpers/localStorageFunc";
import { keyMapsMutation, keyMapsAction } from "../helpers/storeKeys";
import Utility from "../helpers/utility";
import { EVENT_CHANGE_LOCATION, EVENT_POPUP } from "../helpers/analyticsEvents";

export default {
  name: "StoreUnavailableHeader",
  components: {
    VueLottiePlayer: defineAsyncComponent(() => import("vue-lottie-player")),
    AddressCard,
  },
  props: {
    moduleProps: {
      required: false,
      default: StoreUnavailabilityKeys,
    },
  },
  data() {
    return {
      modulePropsData: {},
      animationFailed: false,
      addressCardClass: "tl",
    };
  },
  mounted() {
    this.modulePropsData =
      typeof this.moduleProps != null &&
      typeof this.moduleProps != "null" &&
      typeof this.moduleProps != "undefined"
        ? JSON.parse(this.moduleProps)
        : {};
    EVENT_POPUP({
      subcategory: "oops",
      errorMessage: this.subText,
    });
  },
  methods: {
    onAnimationError() {
      this.animationFailed = true;
    },
    onLottieAnimControl(anim) {
      const svgEl = anim?.renderer?.svgElement;
      if (svgEl) {
        svgEl.setAttribute("preserveAspectRatio", "xMidYMid slice");
      }
    },
    handleChangeClick(e) {
      this.$store.commit(
        keyMapsMutation.UPDATE_SHOW_MANUAL_LOCATION_SCREEN,
        true
      );
      Utility.sendToLocationScreen();
    },

    handleNotifyMeClick(e) {},
    handleProceedDinein() {
      LocalStorageFunc.resetAllSelectedLocations();
      this.$store.commit(
        keyMapsMutation.UPDATE_CURRENT_ORDER_TYPE,
        OrderTypesCode.TAKEAWAY_CODE
      );
      this.$store.commit(
        keyMapsMutation.UPDATE_TAKEAWAY_OR_DINEIN_ON_SELECTION,
        this.nearestTakeawayStore.store
      );
      LocalStorageFunc.setDeliveryTypeStationData(
        this.nearestTakeawayStore.store?.stations[0]
      );
      LocalStorageFunc.updateStoreId(this.nearestTakeawayStore.store?.id);
      LocalStorageFunc.setSelectedStore(this.nearestTakeawayStore.store);
      Utility.redirectToHomeOrRedirectUrl();
    },
    handleProceedTakeaway() {
      LocalStorageFunc.resetAllSelectedLocations();
      this.$store.commit(
        keyMapsMutation.UPDATE_CURRENT_ORDER_TYPE,
        OrderTypesCode.TAKEAWAY_CODE
      );
      this.$store.commit(
        keyMapsMutation.UPDATE_TAKEAWAY_OR_DINEIN_ON_SELECTION,
        this.nearestTakeawayStore.store
      );
      LocalStorageFunc.setDeliveryTypeStationData(
        this.takeawayDineInStations.TAKEAWAY
      );
      LocalStorageFunc.updateStoreId(this.nearestTakeawayStore.store?.id);
      LocalStorageFunc.setSelectedStore(this.nearestTakeawayStore.store);
      Utility.redirectToHomeOrRedirectUrl();
    },
    handleProceedDinein() {
      LocalStorageFunc.resetAllSelectedLocations();
      this.$store.commit(
        keyMapsMutation.UPDATE_CURRENT_ORDER_TYPE,
        OrderTypesCode.DINE_IN_CODE
      );
      this.$store.commit(
        keyMapsMutation.UPDATE_TAKEAWAY_OR_DINEIN_ON_SELECTION,
        this.nearestTakeawayStore.store
      );
      LocalStorageFunc.setDeliveryTypeStationData(
        this.takeawayDineInStations.DINEIN
      );
      LocalStorageFunc.updateStoreId(this.nearestTakeawayStore.store?.id);
      LocalStorageFunc.setSelectedStore(this.nearestTakeawayStore.store);
      Utility.redirectToHomeOrRedirectUrl();
    },

    buttonCTAClickHandler() {
      if (
        this.isLocationUnservicable &&
        !this.isNearByTakeAwayOrDineinAvailable
      ) {
        EVENT_CHANGE_LOCATION({
          subcategory: "not serviceable",
        });
        this.handleChangeClick();
      }
      if (
        this.isLocationUnservicable &&
        this.isNearByTakeAwayOrDineinAvailable
      ) {
        EVENT_CHANGE_LOCATION({
          subcategory: "delivery not available",
        });
        this.handleChangeClick();
      } else if (this.isStoreOffline) {
        EVENT_CHANGE_LOCATION({
          subcategory: "serviceable",
        });
        this.handleNotifyMeClick();
      }
    },
  },
  computed: {
    backgroundImage() {
      if (
        this.isLocationUnservicable &&
        !this.isNearByTakeAwayOrDineinAvailable
      ) {
        return (
          this.modulePropsData?.notAtAllServicableBgImage ||
          StoreUnavailabilityKeys?.notAtAllServicableBgImage
        );
      }
      if (
        this.isLocationUnservicable &&
        this.isNearByTakeAwayOrDineinAvailable
      ) {
        return (
          this.modulePropsData?.nonServicableAreaBgImage ||
          StoreUnavailabilityKeys?.nonServicableAreaBgImage
        );
      } else if (this.isStoreOffline) {
        return (
          this.modulePropsData?.serviceOffBgImage ||
          StoreUnavailabilityKeys?.serviceOffBgImage
        );
      }
    },
    backgroundLottieUrl() {
      if (
        this.isLocationUnservicable &&
        !this.isNearByTakeAwayOrDineinAvailable
      ) {
        return (
          this.modulePropsData?.notAtAllServicableBgLottieUrl ||
          StoreUnavailabilityKeys?.notAtAllServicableBgLottieUrl
        );
      }
      if (
        this.isLocationUnservicable &&
        this.isNearByTakeAwayOrDineinAvailable
      ) {
        return (
          this.modulePropsData?.nonServicableAreaLottieUrl ||
          StoreUnavailabilityKeys?.nonServicableAreaLottieUrl
        );
      } else if (this.isStoreOffline) {
        return (
          this.modulePropsData?.serviceOffLottieUrl ||
          StoreUnavailabilityKeys?.serviceOffLottieUrl
        );
      }
    },
    titleText() {
      if (
        this.isLocationUnservicable &&
        !this.isNearByTakeAwayOrDineinAvailable
      ) {
        return (
          this.modulePropsData?.notAtAllServicableTitle ||
          StoreUnavailabilityKeys?.notAtAllServicableTitle
        );
      }
      if (
        this.isLocationUnservicable &&
        this.isNearByTakeAwayOrDineinAvailable
      ) {
        return (
          this.modulePropsData?.nonServicableAreaTitle ||
          StoreUnavailabilityKeys?.nonServicableAreaTitle
        );
      } else if (this.isStoreOffline) {
        return (
          this.modulePropsData?.serviceOffTitle ||
          StoreUnavailabilityKeys?.serviceOffTitle
        );
      }
      return "";
    },
    subText() {
      if (
        this.isLocationUnservicable &&
        !this.isNearByTakeAwayOrDineinAvailable
      ) {
        EVENT_POPUP({
          subcategory: "oops",
          errorMessage:
            this.modulePropsData?.notAtAllServicableSubtitle ||
            StoreUnavailabilityKeys?.notAtAllServicableSubtitle,
        });
        return (
          this.modulePropsData?.notAtAllServicableSubtitle ||
          StoreUnavailabilityKeys?.notAtAllServicableSubtitle
        );
      }
      if (
        this.isLocationUnservicable &&
        this.isNearByTakeAwayOrDineinAvailable
      ) {
        EVENT_POPUP({
          subcategory: "oops",
          errorMessage:
            this.modulePropsData?.nonServicableAreaSubtitle ||
            StoreUnavailabilityKeys?.nonServicableAreaSubtitle,
        });
        return (
          this.modulePropsData?.nonServicableAreaSubtitle ||
          StoreUnavailabilityKeys?.nonServicableAreaSubtitle
        );
      } else if (this.isStoreOffline) {
        EVENT_POPUP({
          subcategory: "oops",
          errorMessage:
            this.modulePropsData?.serviceOffSubtitle ||
            StoreUnavailabilityKeys?.serviceOffSubtitle,
        });
        return (
          this.modulePropsData?.serviceOffSubtitle ||
          StoreUnavailabilityKeys?.serviceOffSubtitle
        );
      }
      return "";
    },
    buttonCTA() {
      if (
        this.isLocationUnservicable &&
        !this.isNearByTakeAwayOrDineinAvailable
      ) {
        return (
          this.modulePropsData?.notAtAllServicableBtnTitle ||
          StoreUnavailabilityKeys?.notAtAllServicableBtnTitle
        );
      }
      if (
        this.isLocationUnservicable &&
        this.isNearByTakeAwayOrDineinAvailable
      ) {
        return (
          this.modulePropsData?.nonServicableAreaBtnTitle ||
          StoreUnavailabilityKeys?.nonServicableAreaBtnTitle
        );
      } else if (this.isStoreOffline) {
        return (
          this.modulePropsData?.serviceOffBtnTitle ||
          StoreUnavailabilityKeys?.serviceOffBtnTitle
        );
      }
      return "";
    },
    nearbyStoreDividerLabel() {
      return (
        this.modulePropsData?.nearbyStoreDividerLabel ||
        StoreUnavailabilityKeys?.nearbyStoreDividerLabel
      );
    },
    nearbyStoreDividerLeftImage() {
      return (
        this.modulePropsData?.nearbyStoreDividerLeftImage ||
        StoreUnavailabilityKeys?.nearbyStoreDividerLeftImage
      );
    },
    nearbyStoreDividerRightImage() {
      return (
        this.modulePropsData?.nearbyStoreDividerRightImage ||
        StoreUnavailabilityKeys?.nearbyStoreDividerRightImage
      );
    },
    nearestStoreSectionTitle() {
      return (
        this.modulePropsData?.nearestStoreSectionTitle ||
        StoreUnavailabilityKeys?.nearestStoreSectionTitle
      );
    },
    takeawayDineInStations() {
      return this.$store.state.Location.takeawayDineStations?.stationDetails
        ?.length
        ? this.$store.state.Location.takeawayDineStations
        : LocalStorageFunc.getTakeAwayDineinStations();
    },
    nearestTakeawayStore() {
      return this.takeawayDineInStations?.stationDetails?.length
        ? this.takeawayDineInStations?.stationDetails[0]
        : {};
    },
    isLocationUnservicable() {
      return (
        this.$store.state.Location.noDeliveryZoneData?.displayText?.length >
          0 && !this.isNearByTakeAwayOrDineinAvailable
      );
    },
    isStoreOffline() {
      let storeDetails =
        Object.keys(this.$store.state.Location.storeDetails).length > 1
          ? this.$store.state.Location.storeDetails
          : LocalStorageFunc.getLastLocationNewOrLastLocationNewForIp()[0]
              ?.recent;
      return this.selectedOrderType === OrderTypesCode.DELIVERY_CODE
        ? !Boolean(storeDetails?.online)
        : !Boolean(storeDetails?.pickUpEnable) || false;
    },
    isNearByTakeAwayOrDineinAvailable() {
      return this.isNearByTakeAwayAvaialable || this.isNearByDineInAvaialable;
    },
    isNearByStorePickupEnabled() {
      return this.nearestTakeawayStore?.store?.pickUpEnable || false;
    },
    isNearByTakeAwayAvaialable() {
      return (
        this.$store.state.Location.takeawayDineAvailability.TAKEAWAY ||
        this.nearestTakeawayStore?.store?.allowedDeliveryTypeCodes.includes(
          OrderTypesCode.TAKEAWAY_CODE
        ) ||
        false
      );
    },
    isNearByDineInAvaialable() {
      return (
        this.$store.state.Location.takeawayDineAvailability.DINEIN ||
        this.nearestTakeawayStore?.store?.allowedDeliveryTypeCodes.includes(
          OrderTypesCode.DINE_IN_CODE
        ) ||
        false
      );
    },
    showFetchLocationModal() {
      return this.$store.state.Location.showFetchLocationModal;
    },
    selectedOrderType() {
      return (
        this.$store.state.User.selectedOrderType ||
        this.$store.state.User.currentOrderType
      );
    },
    showUnavailableHeader() {
      let showheader =
        (this.isLocationUnservicable || this.isStoreOffline) &&
        !this.showFetchLocationModal &&
        this.isDeliveryOrderType;
      this.$store.commit(
        keyMapsMutation.UPDATE_SHOW_UNAVAILABLE_HEADER,
        showheader
      );
      return showheader;
    },
    showButton() {
      return this.buttonCTA.toLowerCase().trim() != "notify me";
    },
    isDeliveryOrderType() {
      return this.selectedOrderType === OrderTypesCode.DELIVERY_CODE;
    },
  },
};
</script>
